'use strict';

frontendApp.controller('BrowserModalCtrl', ['$scope', '$uibModalInstance', 'title', 'message', 'href', 'hrefTitle', function($scope, $uibModalInstance, title, message, href, hrefTitle) {

    $scope.title = title;
    $scope.message = message;
    $scope.href = href;
    $scope.hrefTitle = hrefTitle;
    
    $scope.cancel = function() {
        $uibModalInstance.dismiss();
    };

    $scope.ok = function() {
        $uibModalInstance.close('ok');
    };

}]);
    